import { EditorState, convertFromRaw } from 'draft-js'

export const convertJSONtoEditorState = (richTextJSONString: string): EditorState => {
  const parsedState = JSON.parse(richTextJSONString)
  const contentState = convertFromRaw(parsedState)
  const editorState = EditorState.createWithContent(contentState)
  return editorState
}
